// src/admin/services/teachers.service.js
import { ref, push, set, update, remove, onValue } from "firebase/database";
import { db } from "./firebaseClient";

// ✅ caminho fixo como você pediu:
const BASE_PATH = "cise/teachers";

export function subscribeTeachers(cb) {
    const r = ref(db, BASE_PATH);

    // retorna o unsubscribe
    const unsub = onValue(r, (snap) => {
        const val = snap.val() || {};
        const list = Object.entries(val).map(([id, data]) => ({ id, ...data }));

        // opcional: ordenar por nome
        list.sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "pt-BR"));

        cb(list);
    });

    return () => unsub();
}

export async function addTeacher(data) {
    const now = Date.now();
    const r = ref(db, BASE_PATH);
    const newRef = push(r);

    await set(newRef, {
        ...data,
        createdAt: now,
        updatedAt: now,
    });

    return newRef.key;
}

export async function updateTeacher(teacherId, data) {
    const r = ref(db, `${BASE_PATH}/${teacherId}`);
    await update(r, { ...data, updatedAt: Date.now() });
}

export async function removeTeacher(teacherId) {
    const r = ref(db, `${BASE_PATH}/${teacherId}`);
    await remove(r);
}